import { render, staticRenderFns } from "./SharerReport.vue?vue&type=template&id=fffa5a12"
import script from "./SharerReport.vue?vue&type=script&lang=js"
export * from "./SharerReport.vue?vue&type=script&lang=js"
import style0 from "./SharerReport.vue?vue&type=style&index=0&id=fffa5a12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports